import { UploadCoinButtonField } from './UploadCoinButtonField'
import { withUploadCoinButtonField } from './withUploadCoinButtonField'

const ConnectedUploadCoinButtonField = withUploadCoinButtonField(
  UploadCoinButtonField
)

export { ConnectedUploadCoinButtonField as UploadCoinButtonField }
